export default __webpack_public_path__ + "static/media/D_05_01_bg.8d548a1d.mp4";